import { ShieldCheck } from "lucide-react";

interface HumanCheckFieldProps {
  question: string;
  value: string;
  onChange: (val: string) => void;
  error?: string;
  verified: boolean;
}

const HumanCheckField = ({ question, value, onChange, error, verified }: HumanCheckFieldProps) => {
  return (
    <div className="rounded-xl border border-input bg-muted/30 p-4">
      <div className="flex items-center gap-2 mb-2">
        <ShieldCheck className={`w-4 h-4 ${verified ? "text-success" : "text-muted-foreground"}`} />
        <span className="text-sm font-medium text-foreground">Quick human check</span>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-sm text-muted-foreground whitespace-nowrap">
          What is <span className="font-semibold text-foreground">{question}</span>?
        </span>
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          value={value}
          onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 3))}
          placeholder="?"
          className="w-16 h-10 px-3 rounded-lg border border-input bg-surface text-center text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all duration-200"
          autoComplete="off"
        />
        {verified && <span className="text-xs text-success font-medium">✓ Verified</span>}
      </div>
      {error && <p className="text-xs text-destructive mt-1.5">{error}</p>}
    </div>
  );
};

export default HumanCheckField;
